import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Say Hi!`}</h2>
    <p>{`Fill out the form below and I'll contact you as soon as possible. `}<br />{`
Alternatively, you can `}<a parentName="p" {...{
        "href": "mailto:rakshan793@gmail.com"
      }}>{`mail me`}</a>{` or find me on `}<a parentName="p" {...{
        "href": "https://www.instagram.com/freakingrocky"
      }}>{`instagram`}</a>{`.`}</p>
    <h4>{`Contact Form:`}</h4>
    <form action="https://formspree.io/f/mgepzqag" method="POST">
    <div style={{
        "width": "100%"
      }}>
        <input type="text" placeholder="Name/Nickname" style={{
          "width": "50%"
        }} name="name" />
        <input type="email" placeholder="Email Address" style={{
          "width": "50%"
        }} name="email" />
        <textarea name="message" cols="30" rows="10" placeholder="How you doing? Let's talk!" style={{
          "width": "100%"
        }}></textarea>
        <button style={{
          "width": "100%"
        }} className="btn btn-dark" type="submit">
            Send Message!
        </button>
    </div>
    </form>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      